export default "__VITE_ASSET__oumIs9ix__"